// API categories define availability; presentation hints only control ordering.
export function buildGrowthRows(rows, hints = []) {
  const order = new Map(hints.map((row, index) => [row.category, index]));
  return rows.map((row) => {
    const value = row.data;
    const present = value !== null && value !== undefined && value !== '';
    return {
      ...row,
      is_big: (hints.find((hint) => hint.category === row.category) || {}).is_big,
      data: present && Number.isFinite(Number(value)) ? (Number(value) * 100).toFixed(2) : '',
    };
  }).sort((a, b) => (order.has(a.category) ? order.get(a.category) : hints.length)
    - (order.has(b.category) ? order.get(b.category) : hints.length));
}

export function commitGrowthRows(rows) {
  return rows.map((row) => {
    const text = String(row.data == null ? '' : row.data).trim();
    if (!text || !Number.isFinite(Number(text))) {
      throw new Error(`${row.category}：请输入有效增速`);
    }
    return { ...row, data: Number(text) / 100 };
  });
}
